import React, { Component } from 'react';
import QuotationMarkIcon from '../../assets/QuotationMark_Red';
import style from './quote.module.scss';

const Quote = ({ quote_text, caption }) => (
  <div className={style.quote}>
    <div className={style.quoteIcon}>
      <QuotationMarkIcon />
    </div>
    <div
      className={style.quoteText}
      dangerouslySetInnerHTML={{
        __html: quote_text,
      }}
    />
    <div
      className={style.quoteCaption}
      dangerouslySetInnerHTML={{ __html: caption }}
    />
  </div>
);

export default Quote;



// WEBPACK FOOTER //
// ./src/components/tour/details/teasers/Quote.js